import { Component, ChangeDetectionStrategy, HostBinding, HostListener, Output, EventEmitter, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-tab',
  standalone: true,
  template: `
    <ng-content />
  `,
})
export class TabComponent {
  public selected = input(false);

  @Output() public tabSelected = new EventEmitter();

  @HostBinding('class.tt-tab') public hostCls = true;

  @HostBinding('class.tt-tab--selected')
  public get selectedClass(): boolean {
    return this.selected();
  }

  @HostListener('click')
  public onClick(): void {
    this.tabSelected.emit();
  }
}
